// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { useMediaQuery, useTheme } from "@3778.care/goban";

export const useIsDesktop = () => {
  const { breakpoints } = useTheme();

  return useMediaQuery(breakpoints.up("md"));
};
